module.exports = __webpack_public_path__ + "img/boston_pizza.a007d62d.jpg";